// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__34ZXC","right":"styles_right__1MrT9"};